/**
 * Dependency-free deep clone. Split out of `app/utils.js` so `BaseObjectStore`
 * (used by nearly every store, including boot-critical ones like
 * `error-store.js`/`count-store.js`/`booking-store.js`) doesn't have to pull in
 * `app/utils.js`'s much heavier transitive graph (`date-time-utils.js` →
 * `luxon`, ~260KB unminified) just for this one function. `app/utils.js`
 * re-exports this for backwards compatibility.
 */
export function deepClone (object) {
    if (object === null || typeof object !== 'object') {
        return object
    }
    if (Array.isArray(object)) {
        return object.map(deepClone)
    }
    const clonedObject = {}
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            clonedObject[key] = deepClone(object[key])
        }
    }
    return clonedObject
}
